export function secondsToTime(seconds: number): string {
    if (seconds < 60) {
        return seconds.toString();
    }

    const minutes = Math.floor((seconds % 3600) / 60);
    const s = prefix(Math.floor(seconds % 60));

    if (minutes < 60) {
        return `${minutes.toString()}:${s}`;
    }

    return `${prefix(Math.floor(seconds / 3600))}:${prefix(minutes)}:${s}`;
}

function prefix(value: number) {
    return value.toString().padStart(2, '0');
}

export function getSecondsUntilDateTime(dateTimeString: string): number {
    const now = new Date();
    const dateTime = new Date(dateTimeString);

    // Calculate the difference in milliseconds
    const differenceInMilliseconds = now.getTime() - dateTime.getTime();

    // Convert the difference to seconds and take the absolute value
    const differenceInSeconds = Math.abs(Math.floor(differenceInMilliseconds / 1000));

    return differenceInSeconds;
}
